export default "__VITE_ASSET__BJzrb0QF__"